function CollapseNumberRange(result) {
  return result;
}
export {
  CollapseNumberRange
};
